import { render, staticRenderFns } from "./PDFNavViewer.component.vue?vue&type=template&id=71a980d6&scoped=true"
import script from "./PDFNavViewer.component.vue?vue&type=script&lang=js"
export * from "./PDFNavViewer.component.vue?vue&type=script&lang=js"
import style0 from "./PDFNavViewer.component.vue?vue&type=style&index=0&id=71a980d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a980d6",
  null
  
)

export default component.exports